// extracted by mini-css-extract-plugin
export var actionText = "_mj-4";
export var container = "_mj-0";
export var leftSection = "_mj-1";
export var rightSection = "_mj-2";
export var settingsButton = "_mj-6";
export var settingsIcon = "_mj-7";
export var shortcut = "_mj-5";
export var shortcutGroup = "_mj-3";